import { CALL_API } from '../middleware/api';

export const SEND_OUTGOING_CALL_DIAL_PAD_SUCCESS = Symbol('SEND_OUTGOING_CALL_DIAL_PAD_SUCCESS');

/** Send outgoing call. */
export function sendOutgoingCall({ phoneNumber, phoneCode, eventId, afterError, afterSuccess }) {
  const body = {
    phone_number: phoneNumber,
    country_code: phoneCode,
    event_id: eventId,
  };

  return {
    [CALL_API]: {
      method: 'post',
      path: '/api/v1/dialpad/call',
      unifier: 'post /api/v1/dialpad/call',
      body,
      afterError,
      afterSuccess,
      skipGlobalErrorHandler: true,
    },
  };
}

/** Finish call. */
export function finishCall() {
  return {
    [CALL_API]: {
      method: 'post',
      path: '/api/v1/dialpad/close_call',
      unifier: 'post /api/v1/dialpad/close_call',
      skipGlobalErrorHandler: true,
    },
  };
}
